export enum TipoRecorrido {
    gr = "GR",
    pr = "PR",
    sl = "SL"
}